import { Script } from 'gatsby';
import React from 'react';

// Golbal declaration of window/analytics
declare global {
  interface Window {
    ChiliPiper: any;
  }
}

// Name of user action
export enum CHILIPIPER {
  demo = '/demo',
  router = 'inbound_router',
  routerGeneric = 'inbound_router_generic',
  routerHSForm = 'inbound_router_demo_f',
  routerPrism = 'inbound_router_prism',
  script = 'https://js.chilipiper.com/marketing.js',
  name = 'perpetua',
  bookingText = 'Thanks! What time works best for a quick call?',
}

const chilipiperLocales: { [key: string]: string } = {
  'en-US': 'en_US',
  de: 'de_DE',
  es: 'es_LA',
  ja: 'ja_JP',
  'zh-CN': 'zh_CN',
};

const ChiliPiperAdd = () => {
  return <Script src={CHILIPIPER.script} />;
};

export default ChiliPiperAdd;

export const chiliPiperSubmitHSForm = async (
  fields: any,
  router: string,
  language: string
) => {
  window?.ChiliPiper?.submit(CHILIPIPER.name, router, {
    map: true,
    lead: {
      ...fields,
    },
    locale: chilipiperLocales[language],
  });
};
